document.addEventListener("DOMContentLoaded", () => {
  let activeSections: NodeListOf<HTMLElement> = document.querySelectorAll("[data-progress-active]")

  for (let activeSection of activeSections) {
    let coords = activeSection.getBoundingClientRect()
    let activeSectionEnd = coords.x + coords.width
    let screenWidth = document.body.getBoundingClientRect().width

    if (activeSectionEnd > screenWidth) {
      activeSection.parentElement.scrollTo({ left: coords.x - 16 })
    }
  }
})

export {}
